import { isNullOrUndefined } from '../validation';
import { ConvertToJSONService } from './convert-to-json.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { DatePipe } from '@angular/common';
import { EncrdecrService } from './../Auth/encrdecr.service';

const headers = { headers: new HttpHeaders({ 'content-type': 'application/json' }) }

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  myDate = new Date();
  todaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');

  ServerUrl = environment.ServerUrl;
  ExchangeStatus = '';
  constructor(private http: HttpClient, private datePipe: DatePipe,
    private EncrdecrService: EncrdecrService, private ConvertToJSON: ConvertToJSONService) { }

  //=======================================Common For All Transaction==================================================

  GetToken() {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Basic ${TOKEN}`,
      })
    }
    return tokenOption;
  }

  GetAllClient(UserType, SubBrokerId): Observable<any> {
    const tokenOption = this.GetToken();
    const url = `${this.ServerUrl}/api/ReportFilter/ReportDetails`;
    const QueryString = `TRANS_TYPE=${this.EncrdecrService.setEncr('USERCODE_WISE_CLIENT')}&LOGIN_ID=${this.EncrdecrService.setEncr('0')}&USER_TYPE=${this.EncrdecrService.setEncr(UserType)}&ZONE_ID=0&REGION_ID=0&BRANCH_ID=0&SB_ID=${this.EncrdecrService.setEncr(SubBrokerId)}&EMP_ID=0&FAMILY_ID=0&CLIENT_ID=0`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  async GetClientUCCDetails(ClientId): Promise<Observable<any>> {
    const url = `/api/BSETransaction/UCCDetails`;
    const QueryString = `ClientBasicInfoId=${ClientId}`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, url,this.GetToken());
    return result;
  }

  GetAMCName(): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/AMC/AMCList`;
    console.log("AMC API Details");
    console.log(url);

    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);

    return this.http.get<any>(url, tokenOption).pipe();
  }

  GetSchemeName(AMCCode, RiskProfileLevel = "", SchemeName = "", PurchaseTransactionMode = "", BSESchemeCode = "", UCCCode = ""): Observable<any> {
    var DataUrl = `${this.ServerUrl}/api/BSESchemeList/BSESchemeList?BSESchemeCode=&SchemeCode=0&AMCCode=${AMCCode}&SchemeType=&SchemeName=${SchemeName}&PurchaseTransactionMode=${PurchaseTransactionMode}&SchemePlan=&PageNumber=1&PageSize=1&SwitchBSESchemeCode=${BSESchemeCode}&UCCCode=${UCCCode}`;

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    //console.log("Scheme API Details");
    //console.log(url);

    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  GetSchemeNamefordirect(AMCCode, DirectCode): Observable<any> {
    const DataUrl = `${this.ServerUrl}/api/BSESchemeList/BSESchemeList?BSESchemeCode=&SchemeCode=0&AMCCode=${AMCCode}&DirectCode=${DirectCode}&SchemeType=&SchemeName=&PurchaseTransactionMode=&SchemePlan=${DirectCode}&PageNumber=1&PageSize=1`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    //console.log("Scheme API Details");
    //console.log(url);

    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  // GetSchemeName(AMCCode): Observable<any> {
  //   const url = `${this.ServerUrl}/api/BSESchemeList/BSESchemeList?BSESchemeCode=&SchemeCode=0&AMCCode=${AMCCode}&SchemeType=&SchemeName=&PurchaseTransactionMode=&SchemePlan=&PageNumber=1&PageSize=1`;
  //   let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
  //   let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
  //   let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
  //   let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
  //   const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
  //   const tokenOption = {
  //     headers:
  //       new HttpHeaders(
  //         {
  //           'Content-Type': 'application/json',
  //           'Authorization': `Basic ${TOKEN}`,
  //         })
  //   }
  //   console.log("SchemeList url -> "+url);
  //   const body = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1])
  //   return this.http.post<any>(url.split('?')[0],body, tokenOption).pipe();
  // }

  GetSelectedSchemeData(AMCCode, BSESchemeCode, SchemePlan): Observable<any> {
    //////
    const DataUrl = `${this.ServerUrl}/api/BSESchemeList/BSESchemeList?BSESchemeCode=${BSESchemeCode}&SchemeCode=0&AMCCode=${AMCCode}&SchemeType=&SchemeName=&PurchaseTransactionMode=&SchemePlan=${SchemePlan}&PageNumber=1&PageSize=1`;

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  BindExistingFolio(ClientId, SchemeCode, BSESchemeCode): Observable<any> {

    const url = `${this.ServerUrl}/api/TransactionGetFolioNumber/Details`;
    const QueryString = `ClientBasicInfoId=${ClientId}&SchemeCode=${SchemeCode}&BSESchemeCode=${BSESchemeCode}`;

    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }

  //=======================================FOR LUMPSUM==================================================
  InvestToLumpsum(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/InvestToLumpsum`;
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, this.GetToken());
  }

  //=======================================FOR LUMPSUM CART==================================================
  InvestToLumpsumCart(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/InvestToLumpsumCart`;
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, this.GetToken());
  }

  //=======================================FOR SIP==================================================
  GetSIPMandate(TRANS_TYPE, UCCCode): Observable<any> {
    const url = `${this.ServerUrl}/api/ClientMandate/Details?TRANS_TYPE=${TRANS_TYPE}&UCCCode=${UCCCode}`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    console.log('Get SIP Mandate')
    console.log(url)
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress)
    return this.http.get<any>(url, tokenOption).pipe();
  }

  GenerateMandate(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/ClientMandate/Details`;

    let date = new Date();
    let rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));

    const request = { 
      data: this.EncrdecrService.setEncr(formData),
      rid: rid,
      jid: this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"))
    }
    return this.http.post<any>(url, request, this.GetToken()).pipe();
  }

  GetSIPDates(BSESchemeCode): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const DataUrl = `${this.ServerUrl}/api/BSESIPDetails/GetBSESIPDetails?BSESchemeCode=${BSESchemeCode}`;
    console.log("Get SIP Start Date");
    //console.log(url);
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress)
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  InvestToSIP(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/BSETransaction/InvestToSIP`;
    console.log("SIP Transaction");
    console.log(url);
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    console.log(JSON.stringify(formData));
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: UserType,
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, tokenOption);

  }

  InvestToSIPCart(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/BSETransaction/InvestToSIPCart`;
    console.log("SIP Transaction");
    console.log(url);
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    console.log(JSON.stringify(formData));
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: UserType,
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, tokenOption);

  }
  //=======================================SIP End==================================================

  //used in switch, redeem, swp, stp
  async GetFromScheme(ClientBasicInfoId, UCCCode = "", UserType = "3", MappingID = "", rid = "", jid = "", initiatedBy = "",Flag2="False",TRANS_TYPE): Promise<Observable<any>> {
    debugger
    const DataUrl = `${this.ServerUrl}/api/BSETransaction/SourceSchemeDetails?ClientBasicInfoId=${ClientBasicInfoId}&Flag=ClientWiseExistingScheme&UCCCode=${UCCCode}&UserType=${UserType}&MappingID=${MappingID}&rid=${rid}&jid=${jid}&initiatedBy=${initiatedBy}&Flag2=${Flag2}&TRANS_TYPE=${TRANS_TYPE}`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    // console.log("Switch API From Scheme");
    //console.log(url);
    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, tokenOption).pipe();
    const result = await this.postAPICall(body, "/api/BSETransaction/SourceSchemeDetails",this.GetToken());
    return result;
  }

  async GetFromScheme_New(ClientBasicInfoId, flag): Promise<Observable<any>> {
    const DataUrl = `${this.ServerUrl}/api/BSETransaction/SourceSchemeDetails?ClientBasicInfoId=${ClientBasicInfoId}&Flag=${flag}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, "/api/BSETransaction/SourceSchemeDetails",this.GetToken());
    return result;
  }






  //used in switch, redeem, swp, stp
  async GetInvestedFolio(ClientBasicInfoId, SchemeCode, HoldingType): Promise<Observable<any>> {
    const url = `${this.ServerUrl}/api/BSETransaction/SourceSchemeDetails`;
    const QueryString = `ClientBasicInfoId=${ClientBasicInfoId}&Flag=ClienFolioNoSchemeBased&SchemeCode=${SchemeCode}`;//&Trans_Type=${HoldingType}
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, "/api/BSETransaction/SourceSchemeDetails",this.GetToken());
    return result;
  }
  //used in switch, swp, stp
  IsDivOption(SchemeCode): Observable<any> {
    const url = `${this.ServerUrl}/api/DropDown/DividentDetails?Flag=AccordDividentOption&SchemeCode=${SchemeCode}`;
    return this.http.get<any>(url, this.GetToken()).pipe();
  }
  //used in swp, stp
  GetFrequency(): Observable<any> {
    const url = `${this.ServerUrl}/api/DropDown/GetDetails?Flag=BSESTPSWPFrequency`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    return this.http.post<any>(url.split('?')[0], body, this.GetToken());
  }
  //used in swp, stp
  Get_STP_SWP_MinAmt(SchemeCode, TransType): Observable<any> {
    const DataUrl = `${this.ServerUrl}/api/BSESIPDetails/GetBSESIPDetails?BSESchemeCode=${SchemeCode}&Flag=STPSWPDetails&TRANS_TYPE=${TransType}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    //return this.http.post<any>(url, body, tokenOption).pipe();
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }
  //=======================================FOR SWITCH==================================================
  InvestToSwitch(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/InvestToSwitch`;
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, this.GetToken());
  }
  //=======================================FOR Redemption==================================================
  InitiateRedemption(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/InvestToRedemption`;
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, this.GetToken());
  }
  //=======================================FOR SWP==================================================
  InvestToSWP(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/InvestToSWP`;
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, this.GetToken());
  }
  //=======================================FOR STP==================================================
  async GetExistingTargetScheme(ClientBasicInfoId, Schemecode, FolioNumber): Promise<Observable<any>> {
    const DataUrl = `${this.ServerUrl}/api/BSETransaction/SourceSchemeDetails?ClientBasicInfoId=${ClientBasicInfoId}&Flag=ClientSchemeByFolioNo&SchemeCode=${Schemecode}&FolioNumber=${FolioNumber}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body).pipe();
    const result = await this.postAPICall(body, "/api/BSETransaction/SourceSchemeDetails",this.GetToken());
    return result;
  }
  InvestToSTP(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/InvestToSTP`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    console.log("STP Transaction Service")
    console.log(url)
    console.log(JSON.stringify(formData))
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, tokenOption);
  }
  //======================================For SWP & SIP=====================================================
  async GetSourceSchemeName(ClientBasicInfoId): Promise<Observable<any>> {
    ////////
    const DataUrl = `${this.ServerUrl}/api/BSETransaction/SourceSchemeDetails?ClientBasicInfoId=${ClientBasicInfoId}&Flag=ClientWiseExistingScheme`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body).pipe();
    const result = await this.postAPICall(body, "/api/BSETransaction/SourceSchemeDetails",this.GetToken());
    return result;
  }

  async GetFolioNumber(ClientBasicInfoId, Schemecode): Promise<Observable<any>> {
    const DataUrl = `${this.ServerUrl}/api/BSETransaction/SourceSchemeDetails?ClientBasicInfoId=${ClientBasicInfoId}&Flag=ClienFolioNoSchemeBased&SchemeCode=${Schemecode}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body).pipe();
    const result = await this.postAPICall(body, "/api/BSETransaction/SourceSchemeDetails",this.GetToken());
    return result;
  }

  async GetExistingFolio(ClientBasicInfoId, Schemecode): Promise<Observable<any>> {
    const DataUrl = `${this.ServerUrl}/api/BSETransaction/SourceSchemeDetails?ClientBasicInfoId=${ClientBasicInfoId}&Flag=ClienFolioNoSchemeBased&SchemeCode=${Schemecode}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body).pipe();
    const result = await this.postAPICall(body, "/api/BSETransaction/SourceSchemeDetails",this.GetToken());
    return result;

  }

  GetDividentOption(SchemeCode): Observable<any> {
    return this.http.get<any>(`${this.ServerUrl}/api/DropDown/DividentDetails?Flag=AccordDividentOption&SchemeCode=${SchemeCode}`).pipe();
  }

  async GetTargetSchemeNAV(Schemecode, UCCCode = ""): Promise<Observable<any>> {
    const DataUrl = `${this.ServerUrl}/api/BSETransaction/SourceSchemeDetails?Flag=BSESTPTargetScheme&SchemeCode=${Schemecode}&UCCCode=${UCCCode}`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    //console.log("STP Target Scheme")
    //console.log(url)

    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, tokenOption).pipe();
    const result = await this.postAPICall(body, "/api/BSETransaction/SourceSchemeDetails",this.GetToken());
    return result;
  }

  GetSWPMINAmt(SchemeCode, TransType): Observable<any> {
    const DataUrl = `${this.ServerUrl}/api/BSESIPDetails/GetBSESIPDetails?BSESchemeCode=${SchemeCode}&Flag=STPSWPDetails&TRANS_TYPE=${TransType}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body);
  }
  //======================================For SWP & SIP END====================================================


  //======================================For BSE CART START====================================================
  AddToCart(formData, rid = "", jid = "", initiatedBy = "") {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/CartMF/Details`;
    console.log('add to cart ')
    console.log(url)
    console.log(formData)
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, tokenOption);
  }
  async CartSummaryList(ClientBasicInfoId, SUB_BROKER_CODE) {
    var Flag = '';
    const CompanyName = environment.CompayName;
    if (CompanyName == "YesSecurities") {
      Flag = "SelectForYes";
    } else {
      Flag = "Select";
    }
    let url = `/api/CartMF/GetDetails`;
    //console.log(url);
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const QueryString = `Flag=${Flag}&ClientBasicInfoId=${ClientBasicInfoId}&JointClientId=0&SUBBROKERCODE=${SUB_BROKER_CODE}&EmployeeCode=`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, tokenOption);
    const result = await this.postAPICall(body, url,tokenOption);
    return result;
  }
  CartUpdateItem(formData) {
    let url = `${this.ServerUrl}/api/CartMF/Details`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, tokenOption);
  }
  CartDeleteItems(formData) {
    let url = `${this.ServerUrl}/api/CartMF/Details`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, tokenOption);
  }
  //======================================For BSE CART END====================================================
  NoOfInstallmetCalculator(StartDate, EndDate, Frequency) {
    debugger
    let sDatesplit = StartDate.split('/');
    let SIPStartDate = sDatesplit[2] + '-' + sDatesplit[1] + '-' + sDatesplit[0];
    let eDatesplit = EndDate.split('/');
    let SIPEndDate = eDatesplit[2] + '-' + eDatesplit[1] + '-' + eDatesplit[0];
    let NumberOfInstallments = 0;
    let days = 0;
    if (SIPStartDate != "") {
      let startDate = new Date(SIPStartDate);
      let endDate = new Date(SIPEndDate);
      days = Math.floor((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
    } else {
      let startDate = new Date(this.todaysDate);
      let endDate = new Date(SIPEndDate);
      days = Math.floor((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
    }
    if (Frequency.toUpperCase() === "WEEKLY") { //WEEKLY / MONTHLY / QUARTERLY / SEMIANNUALLY / ANNUALLY
      NumberOfInstallments = days / 7;
    } else if (Frequency.toUpperCase() === "QUARTERLY") {
      NumberOfInstallments = days / 90;
    } else if (Frequency.toUpperCase() === "SEMIANNUALLY") {
      NumberOfInstallments = days / 180;
    } else if (Frequency.toUpperCase() === "ANNUALLY") {
      NumberOfInstallments = days / 365;
    } else if (Frequency.toUpperCase() === "DAILY") {
      NumberOfInstallments = days / 1;
    } else {
      NumberOfInstallments = days / 30;
    }
    return Math.floor(NumberOfInstallments)//.toFixed(0);
  }

  //----------------------Goal Planning: start------------------------
  RiskProfileDropdownList() {
    const token = this.GetToken();
    let url = `${this.ServerUrl}/api/InvestGoalPortfolio_Mahindra/GetRiskProfiles`;

    return this.http.get<any>(url, token);
  }
  GetClientRiskProfile(ClientBasicInfoId) {
    const token = this.GetToken();
    let url = `${this.ServerUrl}/api/ClientRiskProfile_QuestionAnswer/GetClientRiskProfileNameAndId?ClientBasicInfoId=${ClientBasicInfoId}`;
    return this.http.get<any>(url, token);
  }
  GetPortfolioList(RiskProfile, Amount, Tenure, TRANS_TYPE) {
    let url = `${this.ServerUrl}/api/InvestGoalPortfolio_Mahindra/GetDetails?Flag=&Wealthmfid=0&RiskProfile=${RiskProfile}&Amount=${Amount}&Tenure=${Tenure}&AmountRangeId=0&TRANS_TYPE=${TRANS_TYPE}`;
    const header = this.GetToken();
    return this.http.get<any>(url, header);
  }

  GetPortfolioTypeList() {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=ASSET_TYPE_mym&REFF_ID=&CON_STR=MF&REFF_ID2=&REFF_ID3=`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    let tokenOption = this.GetToken();
    return this.http.post<any>(url.split('?')[0], body, tokenOption);

  }
  GetPortfolioAMCList() {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=AMCName_Goal&REFF_ID=&CON_STR=MF&REFF_ID2=&REFF_ID3=`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    let tokenOption = this.GetToken();
    return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  GetPortfolioSchemeList() {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=SchemeList_ClassCode&REFF_ID=400040&CON_STR=MF&REFF_ID2=49&REFF_ID3=`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    let tokenOption = this.GetToken();
    return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  //----------------------Goal Planning : end------------------------
  GetBSESChemeCode(SchemeCode, DivOption, Flag): Observable<any> {
    //////
    const s_url = `${this.ServerUrl}/api/DropDown/ReportDetails?TRANS_TYPE=BSESchemeCode&CON_STR=MF&REFF_ID=${SchemeCode}&REFF_ID2=${DivOption}`;
    //console.log(url);
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    // const tokenOption = {
    //   headers:
    //     new HttpHeaders(
    //       {
    //         'Content-Type': 'application/json',
    //         'Authorization': `Basic ${TOKEN}`,
    //       })
    // }
    const url = s_url.split('?')[0];
    const QueryString = s_url.split('?')[1];
    const tokenOption = this.GetToken();
    // const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  SendDataTONEFT(body): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/NEFTPaymentPosting/NEFTPaymentPost`;
    return this.http.post<any>(url, body, tokenOption);
  }
  InvestToSwitchEmp(formData): Observable<any> {

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');

    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return this.http.post<any>(`${this.ServerUrl}/api/BSEEMPTransaction/InvestToSwitch`, formData, tokenOption);
  }
  //=======================================FOR Redemption==================================================
  InitiateRedemptionEmp(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/BSEEMPTransaction/InvestToRedemption`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return this.http.post<any>(url, formData, tokenOption);
  }
  //=======================================FOR SWP==================================================
  InvestToSWPEmp(formData): Observable<any> {

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return this.http.post<any>(`${this.ServerUrl}/api/BSEEMPTransaction/InvestToSWP`, formData, tokenOption);
  }

  InvestToSTPEmp(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/BSEEMPTransaction/InvestToSTP`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return this.http.post<any>(url, formData, tokenOption);
  }
  InvestToSIPEmp(formData): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/BSEEMPTransaction/InvestToSIP`;
    return this.http.post<any>(url, formData, tokenOption);
  }
  InitiateTransaction(formData): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/BSEEMPTransaction/InitiateTransaction`;
    return this.http.post<any>(url, formData, tokenOption);
  }
  CheckTransactionData(formData): Observable<any> {

    const url = `${this.ServerUrl}/api/BSEEMPCheckData/InitiateTransaction`;
    return this.http.post<any>(url, formData, headers);
  }
  sendTransactionOTP(formData) {
    //const token = this.GetToken();
    const url = `${this.ServerUrl}/api/OTPTransaction/TransactionSMS`;
    return this.http.post<any>(url, formData, headers);
  }
  SendSuccessEmailSMS(formData) {
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/CommonTransaction/TransactionSMS`;
    return this.http.post<any>(url, formData, token);
  }
  UpdateCartStatus(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/UpdateCartStatus`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return this.http.post<any>(url, formData, tokenOption);
  }
  InsertBucketIntoCart(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/InsertBucketDataIntoCart`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return this.http.post<any>(url, formData, tokenOption);
  }
  GetPortfolioData(TransType, RefId, ConStr, RefId2, RefId3) {
    let url = `${this.ServerUrl}/api/DropDown/GetDetails?TRANS_TYPE=${TransType}&REFF_ID=${RefId}&CON_STR=${ConStr}&REFF_ID2=${RefId2}&REFF_ID3=${RefId3}`;
    let body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(url.split('?')[1]);
    let tokenOption = this.GetToken();
    return this.http.post<any>(url.split('?')[0], body, tokenOption);
  }
  RiskProfileDropdownList_New() {
    const token = this.GetToken();
    let url = `${this.ServerUrl}/api/InvestGoalPortfolio/GetRiskProfiles`;
    return this.http.post<any>(url, null, token);
  }
  GetPortfolioList_New(formdata: any) {
    let url = `${this.ServerUrl}/api/InvestGoalPortfolio/GetDetails`;
    const header = this.GetToken();
    return this.http.post<any>(url, formdata, header);
  }
  SavePortFolioData(formdata: any) {
    let url = `${this.ServerUrl}/api/InvestGoalPortfolio/SaveInvestGoalPortfolio`;
    const header = this.GetToken();
    return this.http.post<any>(url, formdata, header);
  }
  GeneratePaymentGatewayLink(UCCCode, ClientBasicInfoId, TransType) {
    let url = `${this.ServerUrl}/api/BSETransaction/BSEPaymentURL?UCCCode=${UCCCode}&ClientBasicInfoId=${ClientBasicInfoId}&TRANS_TYPE=${TransType}`;
    const header = this.GetToken();
    return this.http.get<any>(url, header);
  }
  GetBSESchemeCode(SchemeCode, FolioNo) {
    let DataUrl = `${this.ServerUrl}/api/BSETransaction/GetBSESchemeCode?SchemeCode=${SchemeCode}&FolioNumber=${FolioNo}&Flag=BSESchemeCode`;
    const header = this.GetToken();
    // const json = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1])
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, header).pipe();

    // return this.http.post<any>(url.split('?')[0], json, header);
  }
  CheckAvailBalance(CLientId) {
    const url = `${this.ServerUrl}/api/LiabilityAccountService/GetCustomerAccountBalanceDetails`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const checkAmount = {

      "TOKEN_ID": token,
      "ClientBasicInfoId": CLientId
    }
    const json = JSON.stringify(checkAmount);

    return this.http.post<any>(url, json, tokenOption);
  }
  GetMandateActivationURL(body: any): Observable<any> {
    const url = `${this.ServerUrl}/api/ClientMandate/GetMandateActivationURL`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  CheckGatewayUrl(Databody): Observable<any> {
    const tokenOption = this.GetToken();
    const url = `${this.ServerUrl}/api/DirectpaymentGateway/DirectPaymentGateway`;
    return this.http.post<any>(url, Databody, tokenOption);
  }
  sendNPSOTP(formData) {
    //const token = this.GetToken();
    const url = `${this.ServerUrl}/api/OTPTransaction/TransactionSMS`;
    return this.http.post<any>(url, formData, headers);
  }
  GetThankYouData(body) {
    const url = `${this.ServerUrl}/api/Authenticate/CheckClientData`;
    return this.http.post<any>(url, body, headers).pipe();
  }
  GetGoalInvestmentSchemeList(formData, method): Observable<any> {
    const url = `${this.ServerUrl}/api/ExploreFund/${method}`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken());
  }
  //Added By Jay
  GetSTPSWPDetails(body,rid="",jid="",userType=0, initiatedBy=""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/GetBSESWPSTPSchemeDetails`;
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(body)),
      rid: rid,
      jid: jid,
      userType: userType,
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, this.GetToken());
  }

  GetClientExchangeStatus() {
    return this.ExchangeStatus
  }

  SetClientExchangeStatus(status) {
    this.ExchangeStatus = status
  }
  async GetClientExchangeStatusByID(ClientId) {

    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=GetClientExchangeStatusByID&REFF_ID=${ClientId}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details",this.GetToken());
    return result;

  }
  //Added by Devang Mehta On 03/12/2024
  async GetSchemeCategory() {

    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=CustomizeCategory&CON_STR=MF`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details",this.GetToken());
    return result;

  }

  async GetBankAccountNumber(UccCode: string): Promise<Observable<any>> {
    const DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=BankDetailsUCC&REFF_ID=${UccCode}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details",this.GetToken());
    return result;
  }

  GetSchemes(AMCCode = "", RiskProfileLevel = "", SchemeName = "", Category = ""): Observable<any> {
    debugger
    var DataUrl = `${this.ServerUrl}/api/BSESchemeList/BSESchemeList?BSESchemeCode=&SchemeCode=0&AMCCode=${AMCCode}&SchemeType=&SchemeName=${SchemeName}&Category=${Category}&PurchaseTransactionMode=&SchemePlan=&PageNumber=1&PageSize=1`;

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    //console.log("Scheme API Details");
    //console.log(url);

    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  //Added By Devang Mehta On 24-12-2024
  GetSchemesDematPhysical(AMCCode = "", RiskProfileLevel = "", SchemeName = "", Category = "", PurchaseTransactionMode, UCCCode = ""): Observable<any> {
    debugger
    var DataUrl = `${this.ServerUrl}/api/BSESchemeList/BSESchemeList?BSESchemeCode=&SchemeCode=0&AMCCode=${AMCCode}&SchemeType=&SchemeName=${SchemeName}&Category=${Category}&PurchaseTransactionMode=${PurchaseTransactionMode}&SchemePlan=&PageNumber=1&PageSize=1&UCCCode=${UCCCode}`;

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    //console.log("Scheme API Details");
    //console.log(url);

    console.log(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  //End By Devang Mehta

  async GetClientUCCDetailsNew(ClientId, Flag = "", MappingId = '', rid = "", jid = "", UserType = "0", initiatedBy = ""): Promise<Observable<any>> {
    const url = `/api/BSETransaction/UCCDetails`;
    const QueryString = `ClientBasicInfoId=${ClientId}&Flag=${Flag}&REFF_ID=${MappingId}&rid=${rid}&jid=${jid}&UserType=${UserType}&initiatedBy=${initiatedBy}`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, url,this.GetToken());
    return result;
  }

  GetNetBankingPaymentPage(request: any) {
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/BSETransaction/GetPaymentURLBSE`;
    return this.http.post<any>(url, request, token);
  }
  async FetchClientTransactDetails(body): Promise<Observable<any>> {
    const url = `/api/BSETransaction/FetchClientTransactDetails`;
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, url,this.GetToken());
    return result;
  }
  InvestToLumpsumCheque(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/ChequeCollectionDeposit/Details`;
    return this.http.post<any>(url, formData, this.GetToken());
  }

  GetSBRMEUINDetails(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/EUINController/GetEUINDetails`;
    return this.http.post<any>(url, formData, this.GetToken());
  }


  BindExistingFolioUCC(ClientId, SchemeCode, BSESchemeCode, UccCode, rid = "", jid = "", UserType = "0", initiatedBy = ""): Observable<any> {

    const url = `${this.ServerUrl}/api/TransactionGetFolioNumber/DetailsUCC`;
    const QueryString = `ClientBasicInfoId=${ClientId}&SchemeCode=${SchemeCode}&BSESchemeCode=${BSESchemeCode}&UCCCode=${UccCode}&rid=${rid}&jid=${jid}&UserType=${UserType}&initiatedBy=${initiatedBy}`;

    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }

  async CartSummaryListIIFL(ClientBasicInfoId, SUB_BROKER_CODE, EmployeeCode, rid = "", jid = "", UserType = "0", initiatedBy = "") {
    var Flag = '';
    const CompanyName = environment.CompayName;
    if (CompanyName == "YesSecurities") {
      Flag = "SelectForYes";
    } else {
      Flag = "Select";
    }
    let url = `/api/CartMF/GetDetails`;
    //console.log(url);
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const QueryString = `Flag=${Flag}&ClientBasicInfoId=${ClientBasicInfoId}&JointClientId=0&SUBBROKERCODE=${SUB_BROKER_CODE}&EmployeeCode=${EmployeeCode}&rid=${rid}&jid=${jid}&initiatedBy=${initiatedBy}&UserType=${UserType}`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, tokenOption);
    const result = await this.postAPICall(body, url,tokenOption);
    return result;
  }

  CartSummaryListCount(ClientBasicInfoId, SUB_BROKER_CODE) {
    var Flag = '';
    const CompanyName = environment.CompayName;
    if (CompanyName == "YesSecurities") {
      Flag = "SelectForYes";
    } else {
      Flag = "Select";
    }
    let url = `${this.ServerUrl}/api/CartMF/GetDetailsCount`;
    //console.log(url);
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const QueryString = `Flag=${Flag}&ClientBasicInfoId=${ClientBasicInfoId}&JointClientId=0&SUBBROKERCODE=${SUB_BROKER_CODE}&EmployeeCode=`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption);
  }

  getFreeUnitsForRedeem(formData: any): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/GetFreeUnitsForRedeem`;
    return this.http.post<any>(url, formData, this.GetToken());
  }

  PauseSIP(formData): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/BSETransaction/PauseSIP`;
    console.log("SIP Transaction");
    console.log(url);
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    console.log(JSON.stringify(formData));
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, tokenOption);

  }
  //End By Devang Mehta

  //Added by Dalsukh -
  fetchClientTransactDetail(formData) {
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/BSEEMPTransaction/fetchClientTransactDetail`;
    return this.http.post<any>(url, formData, token).pipe();
  }

  //Added By Devang Mehta on 22-01-2025
  EmpCancelPauseSIP(formData) {
    const url = `${this.ServerUrl}/api/EmpCancelAndPauseSIP/EmpCancelSIP`;
    return this.http.post<any>(url, formData, this.GetToken());
  }
  CheckTransactionDataPauseCancelSIP(formData): Observable<any> {

    const url = `${this.ServerUrl}/api/EmpCancelAndPauseSIP/GetTransactionData`;
    return this.http.post<any>(url, formData, headers);
  }

  CheckTransactionDataShiftMandate(formData): Observable<any> {

    const url = `${this.ServerUrl}/api/EmpShiftMandaterController/GetTransactionData`;
    return this.http.post<any>(url, formData, headers);
  }


  fetchClientTransactDetailPauseCancelSIP(formData) {
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/EmpCancelAndPauseSIP/fetchClientTransactDetail`;
    return this.http.post<any>(url, formData, token).pipe();
  }
  BSECartTransactionLumpsum(formData): Observable<any> {
    const url = `${this.ServerUrl}/api/BSECartTransaction/InvestToLumpsumCart`;
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, this.GetToken());
  }

  GetClientUCCDetailsMultipleClientId(ClientId): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/UCCDetailsMultipleClientId`;
    const QueryString = `ClientBasicInfoId=${ClientId}`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }
  GetMandateActivationURLAssisted(body: any): Observable<any> {
    const url = `${this.ServerUrl}/api/ClientMandate/GetMandateActivationURLAssisted`;
    const tokenOption = this.GetToken();
    return this.http.post<any>(url, body, tokenOption).pipe();
  }

  GetPauseDetails(formData: any): Observable<any> {

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/BSETransaction/PauseSIPDetails`;
    console.log("SIP Transaction");
    console.log(url);
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    console.log(JSON.stringify(formData));
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, tokenOption);

  }

  ShiftMandate(formData): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/BSETransaction/MandateShift`;
    console.log("SIP Transaction");
    console.log(url);
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    console.log(JSON.stringify(formData));
    let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, tokenOption);

  }

  fetchClientTransactDetailShiftMandate(formData) {
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/EmpShiftMandaterController/fetchClientTransactDetail`;
    return this.http.post<any>(url, formData, token).pipe();
  }

  EmpShiftMandate(formData) {
    const url = `${this.ServerUrl}/api/EmpShiftMandaterController/EmpShiftMandate`;
    return this.http.post<any>(url, formData, this.GetToken());
  }

  //Added By Devang For OM - 729 On 16-05-2025
  fetchClientTransactDetail_New(formData) {
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/BSEEMPTransaction/FetchBSETransactDetail_New`;
    return this.http.post<any>(url, formData, token).pipe();
  }

  DeletePendingTransaction(formData){
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/BSEEMPTransaction/DeletePendingTransaction`;
    return this.http.post<any>(url,formData,token).pipe();
  }
  //End By Devang

  //Added By Devang On 23-06-2025 for OM - 2431
  GetSelectedSchemeDataBasedOnUccMode(AMCCode, BSESchemeCode, SchemePlan,UccMode): Observable<any> {
    //////
    const DataUrl = `${this.ServerUrl}/api/BSESchemeList/BSESchemeList?BSESchemeCode=${BSESchemeCode}&SchemeCode=0&AMCCode=${AMCCode}&SchemeType=&SchemeName=&PurchaseTransactionMode=${UccMode}&SchemePlan=${SchemePlan}&PageNumber=1&PageSize=1`;

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, tokenOption).pipe();
  }
  //Added By Devang End

  //Added by Dalsukh
  GetClientUCCDetailsNew_Nominee(EmpCode, SubbrokerCode = "", UserType = ''): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/UCCDetails_Nominee`;
  //const url = `${this.ServerUrl}/api/NomineeDetailsStagging/UCCDetails_Nominee`;
    const QueryString = `EmployeeCode=${EmpCode}&SubbrokerCode=${SubbrokerCode}&UserType=${UserType}`;
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any>(url, body, this.GetToken()).pipe();
  }

  async GetBankAccountNumber_DpHoldoing(UccCode: string): Promise<Observable<any>> {
    const DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=BankDetailsUCC_Dpholding&REFF_ID=${UccCode}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details",this.GetToken());
    return result;
  }

  VerifyChequeNo(request: any): Observable<any>{
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/ChequeCollectionDeposit/IsChequeExists`;
    return this.http.post<any>(url, request, token);
  }
  //Added By Akash Mahatao - IIFL 1163
  EmpCancelPauseSTPSWP(formData) {
    const url = `${this.ServerUrl}/api/EmpCancelAndPauseSIP/EmpCancelSTPSWP`;
    return this.http.post<any>(url, formData, this.GetToken());
  }

  CheckTransactionDataPauseCancelSTPSWP(formData): Observable<any> {

    const url = `${this.ServerUrl}/api/EmpCancelAndPauseSIP/GetSTPSWPTransactionData`;
    return this.http.post<any>(url, formData, headers);
  }

  fetchClientTransactDetailPauseCancelSTPSWP(formData) {
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/EmpCancelAndPauseSIP/fetchClientTransactDetailForSTPSWP`;
    return this.http.post<any>(url, formData, token).pipe();
  }

  CancelToSTP(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    // const url = `${this.ServerUrl}/api/BSETransaction/InvestToSTP`;
    const url = `${this.ServerUrl}/api/BSETransaction/CancelSTP`;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let User_Type = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + User_Type + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    console.log("STP Transaction Service")
    console.log(url)
    console.log(JSON.stringify(formData))
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, tokenOption);
  }

  CancelToSWP(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/CancelSWP`;
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, this.GetToken());
  }
  //Added by Tishya for IIFL - 1637
  Shift_SIPToXSIP(formData,rid = "", jid = "", initiatedBy = ""): Observable<any> {
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    const url = `${this.ServerUrl}/api/BSETransaction/Shift_SIPToXSIP`;
    console.log("SIP Transaction");
    console.log(url);
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    console.log(JSON.stringify(formData));
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    // let request = { data: this.EncrdecrService.setEncr(JSON.stringify(formData)) }
    return this.http.post<any>(url, request, tokenOption);

    
  }
  fetchClientTransactDetailShiftSIPToXSIP(formData) {
    const token = this.GetToken();
    const url = `${this.ServerUrl}/api/EmpShiftMandaterController/FetchBSETransactDetailShiftSIPToXSIP`;
    
    return this.http.post<any>(url, formData, token).pipe();
  }
  CheckTransactionDataShiftSIPToXSIP(formData): Observable<any> {

    const url = `${this.ServerUrl}/api/EmpShiftMandaterController/GetTransactionData_SIPToXSIP`;
    return this.http.post<any>(url, formData, headers);
  }

  async postAPICall(Request: any, URL: any,headersdy = {}): Promise<any> {
    let Url = `${this.ServerUrl}${URL}`;
    // let Url = `http://localhost:2010/${URL}`;

    let KeyPair = await this.EncrdecrService.getKeyPair();
    Request.publicKey = KeyPair.publicKeySpkiBase64;

    let EncryptedData = await this.EncrdecrService.encryptJson(Request, environment.RSA_PUBLIC_KEY_BASE64);

    let body = {
      "EncryptedData": EncryptedData.encryptedData,
      "dvfv": EncryptedData.encryptedKey,
      "sdcsd": EncryptedData.iv
    };
    if(!headersdy){
      headersdy = headers
    }
    const response = await firstValueFrom(this.http.post<any>(Url, body, headersdy));

    const DecryptedResponse = this.EncrdecrService.decryptResponse(
      response.EncryptedDataBase64,
      response.EncryptedAesKeyBase64,
      response.IvBase64,
      KeyPair.privateKeyPem
    );

    return DecryptedResponse;
  }
  
  //siddhesh_21072026
   
    GetNetBankingPaymentPageIncred(formData, rid = "", jid = "", initiatedBy = ""): Observable<any> {
    const url = `${this.ServerUrl}/api/BSETransaction/GetPaymentURLBSEIncred`;
    let request = { 
      data: this.EncrdecrService.setEncr(JSON.stringify(formData)),
      rid: rid,
      jid: jid,
      userType: this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0')),
      initiatedBy: initiatedBy 
    }
    return this.http.post<any>(url, request, this.GetToken());
  }
   async ValidateUPIID(RefID) {
    let DataUrl = `${this.ServerUrl}/api/DropDown/Details?TRANS_TYPE=UPIValidation&REFF_ID=${RefID}&CON_STR=SMC`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    // return this.http.post<any>(url, body, this.GetToken()).pipe();
    const result = await this.postAPICall(body, "/api/DropDown/Details",this.GetToken());
    return result;
  }
  //Ended by Tishya
}
